import { observer, inject } from "mobx-react";
import { MobileBox } from "./Common";
import MobileHeader from "../layouts/MobileHeader";
import { Role } from "../stores/userStore";
import RepairMessageList from "./RepairMessageList";
import { useEffect, useState } from "react";

const MobileRepairPagesMessages = ({ userStore, tenantsStore, repairPagesStore }) => {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        const allNewRepairMessages = repairPagesStore.allRepairMessages?.filter((msg) => msg.ISTENANT !== "Y" && msg.ISNEW === "Y")?.map(msg => ({ ...msg, REPAIRMSG: true })) || [];
        const allNewMessages = tenantsStore.allMessages?.filter((msg) => msg.WASREADFLAG !== "Y") || [];
        setMessages([...allNewRepairMessages, ...allNewMessages]);
    }, [repairPagesStore.allRepairMessages, tenantsStore.allMessages])

    return (
        <>
            <MobileHeader
                name={userStore.userDetails.NAME}

                navigateTo={"messages"}
                admin={userStore.userDetails.role === Role.Admin}
            />
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                }}
            >
                <MobileBox
                    flexBasis={70}
                    style={{ height: "100vh", width: "100%", borderRadius: 0 }} >
                    <RepairMessageList project={tenantsStore.selectedProject}
                        newMessages={messages} />



                </MobileBox >
            </div >
        </>
    );
};

export default inject("userStore", "tenantsStore", "repairPagesStore")(observer(MobileRepairPagesMessages));
